export const ADD_ALL_CLIENT_BRANDS_REQUEST = 'ADD_ALL_CLIENT_BRANDS_REQUEST';
export const ADD_ALL_CLIENT_BRANDS_SUCCESS = 'ADD_ALL_CLIENT_BRANDS_SUCCESS';
export const ADD_ALL_CLIENT_BRANDS_ERROR = 'ADD_ALL_CLIENT_BRANDS_ERROR';

export const GET_BRANDS_REQUEST = 'GET_BRANDS_REQUEST';
export const GET_BRANDS_SUCCESS = 'GET_BRANDS_SUCCESS';
export const GET_BRANDS_ERROR = 'GET_BRANDS_ERROR';

export const GET_ALL_CLIENT_BRANDS_REQUEST = 'GET_ALL_CLIENT_BRANDS_REQUEST';
export const GET_ALL_CLIENT_BRANDS_SUCCESS = 'GET_ALL_CLIENT_BRANDS_SUCCESS';
export const GET_ALL_CLIENT_BRANDS_ERROR = 'GET_ALL_CLIENT_BRANDS_ERROR';

export const GET_CLIENT_BRAND_WITH_WINES_REQUEST =
  'GET_CLIENT_BRAND_WITH_WINES_REQUEST';
export const GET_CLIENT_BRAND_WITH_WINES_SUCCESS =
  'GET_CLIENT_BRAND_WITH_WINES_SUCCESS';
export const GET_CLIENT_BRAND_WITH_WINES_ERROR =
  'GET_CLIENT_BRAND_WITH_WINES_ERROR';

export const GET_RIVAL_BRAND_WITH_WINES_REQUEST =
  'GET_RIVAL_BRAND_WITH_WINES_REQUEST';
export const GET_RIVAL_BRAND_WITH_WINES_SUCCESS =
  'GET_RIVAL_BRAND_WITH_WINES_SUCCESS';
export const GET_RIVAL_BRAND_WITH_WINES_ERROR =
  'GET_RIVAL_BRAND_WITH_WINES_ERROR';

export const UPDATE_CLIENT_BRAND_REQUEST = 'UPDATE_CLIENT_BRAND_REQUEST';
export const UPDATE_CLIENT_BRAND_SUCCESS = 'UPDATE_CLIENT_BRAND_SUCCESS';
export const UPDATE_CLIENT_BRAND_ERROR = 'UPDATE_CLIENT_BRAND_ERROR';

export const UPDATE_RIVAL_BRAND_REQUEST = 'UPDATE_RIVAL_BRAND_REQUEST';
export const UPDATE_RIVAL_BRAND_SUCCESS = 'UPDATE_RIVAL_BRAND_SUCCESS';
export const UPDATE_RIVAL_BRAND_ERROR = 'UPDATE_RIVAL_BRAND_ERROR';
